var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lk"},[_c('LayoutFrontTopbar'),_c('section',{staticClass:"lk-main",staticStyle:{"min-height":"100%"}},[_c(_vm.layout,{tag:"component"},[_c('v-container')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }